module.exports = __webpack_public_path__ + "images/bubbleLight.2dee107f.webp";